import {
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface Parameter {
    replacementProdctResult: any
}

type HandlerType = CustomApiHandler<Parameter>;

export const RequestCompleted: HandlerType = props => {
    props.dispatch({
        type: "Custom/ReplacementProduct/SetProduct",
        replacementProdctResult: props.parameter.replacementProdctResult
    });
};


export const chain = [RequestCompleted];

const saveReplaceProductOnPDP = createHandlerChainRunner(chain, "SaveReplaceProductOnPDP");
export default saveReplaceProductOnPDP;
